import { useState } from "react";
import { useFetch } from "../../hooks/useFetch";
import { money } from "../../lib/api";
import { Loading } from "../../components/States";
import { PageHeader } from "../../components/PageHeader";
import { StageBar, StatusPill } from "../../components/StageBar";
import { useNavigate } from "react-router-dom";
import { Building2, Home, ChevronRight, ArrowLeft } from "lucide-react";

export default function BuilderCommunities() {
  const communities = useFetch("/communities");
  const lots = useFetch("/lots");
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  if (communities.loading || lots.loading) return <Loading />;

  const lotsFor = (cid) => (lots.data || []).filter((l) => l.community_id === cid);

  if (selected) {
    const c = communities.data.find((x) => x.id === selected);
    return (
      <div className="space-y-6">
        <button onClick={() => setSelected(null)} className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-300" data-testid="back-communities">
          <ArrowLeft size={16} /> All communities
        </button>
        <PageHeader eyebrow={c.city} title={c.name} subtitle={`${lotsFor(selected).length} lots wired · ${c.jurisdiction}`} />
        <div className="space-y-3">
          {lotsFor(selected).map((l) => (
            <div key={l.id} onClick={() => navigate(`/builder/communities/lot/${l.id}`)} className="hw-card cursor-pointer p-5 transition hover:border-cyan-500/40 hw-rise" data-testid={`b-lot-${l.id}`}>
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-500/10 text-cyan-300"><Home size={18} /></div>
                  <div>
                    <div className="font-semibold text-white">{l.label}</div>
                    <div className="text-sm text-slate-400">{l.address}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <StatusPill status={l.inspection_status} />
                  <ChevronRight size={18} className="text-slate-600" />
                </div>
              </div>
              <div className="mt-4"><StageBar stage={l.stage} /></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Your Developments" title="Communities" subtitle="Drill into any community to see every lot's electrical phase." />
      <div className="grid gap-5 md:grid-cols-2">
        {(communities.data || []).map((c) => {
          const cl = lotsFor(c.id);
          return (
            <div key={c.id} onClick={() => setSelected(c.id)} className="hw-card cursor-pointer overflow-hidden transition hover:border-cyan-500/40 hw-rise" data-testid={`b-community-${c.id}`}>
              <div className="relative h-28 bg-gradient-to-br from-cyan-900/40 to-slate-900">
                <div className="absolute inset-0 grid-texture opacity-50" />
                <div className="absolute bottom-3 left-5 flex items-center gap-2">
                  <Building2 size={18} className="text-cyan-300" />
                  <div className="font-head text-2xl font-bold text-white">{c.name}</div>
                </div>
              </div>
              <div className="flex items-center justify-between p-5">
                <span className="text-sm text-slate-400">{c.city}</span>
                <span className="hw-badge">{cl.length} lots · {money(cl.reduce((a, l) => a + l.contract_price, 0))}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
